import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2b5486c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout__footer" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "container container_wide" }
const _hoisted_4 = { class: "footer__top" }
const _hoisted_5 = { class: "footer__left" }
const _hoisted_6 = {
  class: "footer-logo",
  href: "#"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "footer__right" }
const _hoisted_9 = {
  key: 0,
  class: "footer__link"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.eaivt.org/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logos/eaivt.png",
    alt: "E.A.I.V.T. logo"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "footer__socials" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#facebook" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#instagram" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "footer__left" }
const _hoisted_20 = { class: "footer__copy" }
const _hoisted_21 = { class: "footer__nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createElementVNode("img", {
                class: "logo",
                src: _ctx.logoSrc,
                alt: `${_ctx.brandLabel} logo`
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.shouldHideEaivtLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                href: _ctx.footerData?.facebook_link,
                target: "_blank",
                rel: "nofollow"
              }, _hoisted_15, 8, _hoisted_13),
              _createElementVNode("a", {
                href: _ctx.footerData?.instagram_link,
                target: "_blank",
                rel: "nofollow"
              }, _hoisted_18, 8, _hoisted_16)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["footer__bottom", { 'is-work-in-progress-page': _ctx.isWorkInProgressPage }])
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.footerData?.copyright), 1),
            _createElementVNode("nav", _hoisted_21, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToTermsAndConditions && _ctx.redirectToTermsAndConditions(...args)))
                  }, [
                    _createVNode(_component_i18n_t, { keypath: "footer.nav.terms" })
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToPrivacy && _ctx.redirectToPrivacy(...args)))
                  }, [
                    _createVNode(_component_i18n_t, { keypath: "footer.nav.privacy" })
                  ])
                ])
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}